(function () {
  var ROOT_SELECTOR = '[data-featured-collection]';
  var VIEWPORT_SELECTOR = '[data-featured-collection-viewport]';
  var TRACK_SELECTOR = '[data-featured-collection-track]';
  var PREV_SELECTOR = '[data-featured-collection-prev]';
  var NEXT_SELECTOR = '[data-featured-collection-next]';
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isMobileViewport() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function getMaxScroll(viewport) {
    return Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
  }

  function getCards(track) {
    if (!track) return [];

    return Array.prototype.filter.call(track.children, function (child) {
      return child.classList && child.classList.contains('product-card');
    });
  }

  function getStepDistance(track, viewport) {
    var cards = getCards(track);

    if (cards.length > 1) {
      return Math.max(cards[1].offsetLeft - cards[0].offsetLeft, cards[0].offsetWidth);
    }

    if (cards.length === 1) return cards[0].offsetWidth;
    return viewport.clientWidth * 0.72;
  }

  function updateButtons(root) {
    var viewport = root.querySelector(VIEWPORT_SELECTOR);
    var prev = root.querySelector(PREV_SELECTOR);
    var next = root.querySelector(NEXT_SELECTOR);
    if (!viewport || !prev || !next) return;

    var isRail = root.dataset.featuredCollectionLayout === 'rail-row';
    var maxScroll = getMaxScroll(viewport);
    var disabled = !isRail || isMobileViewport() || maxScroll <= 2;

    prev.disabled = disabled || viewport.scrollLeft <= 2;
    next.disabled = disabled || viewport.scrollLeft >= maxScroll - 2;
  }

  function initRoot(root) {
    if (!root || root.dataset.featuredCollectionBound === 'true') return;

    var viewport = root.querySelector(VIEWPORT_SELECTOR);
    var track = root.querySelector(TRACK_SELECTOR);
    var prev = root.querySelector(PREV_SELECTOR);
    var next = root.querySelector(NEXT_SELECTOR);
    if (!viewport || !track) return;

    var cleanups = [];
    var drag = null;
    var suppressClickTimer = null;

    function on(target, eventName, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      target.addEventListener(eventName, handler, options);
      cleanups.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function shouldBindDesktopRail() {
      return root.dataset.featuredCollectionLayout === 'rail-row' && !isMobileViewport();
    }

    function syncState() {
      if (!shouldBindDesktopRail()) {
        viewport.classList.remove('is-dragging');
      }

      root.__featuredCollectionTarget = viewport.scrollLeft;
      updateButtons(root);
    }

    function go(direction) {
      if (!shouldBindDesktopRail()) return;

      viewport.scrollBy({
        left: Math.max(getStepDistance(track, viewport), viewport.clientWidth * 0.78) * direction,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function isExcluded(event) {
      var target = event.target && event.target.closest ? event.target : null;

      return !target ||
        target.closest('.featured-collection__controls, button, input, select, textarea, [data-product-card-quick-view]');
    }

    function onPointerDown(event) {
      if (!shouldBindDesktopRail() || getMaxScroll(viewport) <= 2 || isExcluded(event)) return;

      root.__featuredCollectionTarget = viewport.scrollLeft;
      root.__featuredCollectionSuppressClick = false;

      drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        scrollLeft: viewport.scrollLeft,
        active: false
      };

    }

    function onPointerMove(event) {
      if (!drag || drag.id !== event.pointerId) return;

      var deltaX = event.clientX - drag.x;
      var deltaY = event.clientY - drag.y;

      if (!drag.active) {
        if (Math.abs(deltaX) < 8 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        drag.active = true;
        root.__featuredCollectionSuppressClick = true;
        viewport.classList.add('is-dragging');
        if (typeof viewport.setPointerCapture === 'function') {
          viewport.setPointerCapture(event.pointerId);
        }
      }

      event.preventDefault();
      viewport.scrollLeft = clamp(drag.scrollLeft - deltaX, 0, getMaxScroll(viewport));
      root.__featuredCollectionTarget = viewport.scrollLeft;
      updateButtons(root);
    }

    function onPointerEnd(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var wasActive = drag.active;

      if (wasActive && typeof viewport.releasePointerCapture === 'function') {
        try {
          viewport.releasePointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture can be released by the browser before this handler.
        }
      }

      drag = null;
      viewport.classList.remove('is-dragging');

      if (wasActive) {
        if (suppressClickTimer) window.clearTimeout(suppressClickTimer);
        suppressClickTimer = window.setTimeout(function () {
          root.__featuredCollectionSuppressClick = false;
          suppressClickTimer = null;
        }, 120);
      }
    }

    function onClick(event) {
      if (!root.__featuredCollectionSuppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      root.__featuredCollectionSuppressClick = false;
      if (suppressClickTimer) {
        window.clearTimeout(suppressClickTimer);
        suppressClickTimer = null;
      }
    }

    function onResize() {
      syncState();
    }

    root.dataset.featuredCollectionBound = 'true';
    root.__featuredCollectionTarget = viewport.scrollLeft;

    on(prev, 'click', function () {
      go(-1);
    });
    on(next, 'click', function () {
      go(1);
    });
    on(viewport, 'scroll', function () {
      root.__featuredCollectionTarget = viewport.scrollLeft;
      updateButtons(root);
    }, { passive: true });
    on(viewport, 'pointerdown', onPointerDown);
    on(viewport, 'pointermove', onPointerMove);
    on(viewport, 'pointerup', onPointerEnd);
    on(viewport, 'pointercancel', onPointerEnd);
    on(viewport, 'click', onClick, true);
    on(window, 'resize', onResize, { passive: true });

    syncState();

    root.__featuredCollectionCleanup = function () {
      if (suppressClickTimer) {
        window.clearTimeout(suppressClickTimer);
        suppressClickTimer = null;
      }
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      cleanups = [];
      root.dataset.featuredCollectionBound = 'false';
      root.__featuredCollectionCleanup = null;
    };
  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (typeof root.__featuredCollectionCleanup === 'function') {
        root.__featuredCollectionCleanup();
      }
    });
  });
})();
